export default store => ({
  path: "/users",

  onEnter: (nextState, transition) => {
    const { auth, user } = store.getState();
    if (!user.data.authorities.includes("ROLE_ADMIN")) {
      transition({ pathname: "/alerts/stats" });
    }
  },

  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const UsersLayout = require("./components/UsersLayout").default;
        cb(null, UsersLayout);
      },
      "users"
    );
  },

  getIndexRoute(nextState, cb) {
    cb(null, {
      getComponent(nextState, callback) {
        require.ensure(
          [],
          require => {
            const UsersList = require("./containers/UsersContainer").default;
            callback(null, UsersList);
          },
          "users-list"
        );
      }
    });
  },

  getChildRoutes(location, cb) {
    cb(
      null,
      [
        {
          path: "nuevo",
          getComponent(nextState, callback) {
            require.ensure(
              [],
              require => {
                const UserForm = require("./containers/UserFormContainer")
                  .default;
                callback(null, UserForm);
              },
              "user-form"
            );
          }
        },

        {
          path: ":id/editar",
          getComponent(nextState, callback) {
            require.ensure(
              [],
              require => {
                const UserForm = require("./containers/UserFormContainer")
                  .default;
                callback(null, UserForm);
              },
              "user-edit-form"
            );
          }
        },

        {
          path: ":id",
          getComponent(nextState, callback) {
            require.ensure(
              [],
              require => {
                const UserDetail = require("./containers/UserDetailContainer")
                  .default;
                callback(null, UserDetail);
              },
              "user-detail"
            );
          }
        }
      ],
      "alerts-sections"
    );
  }
});



// WEBPACK FOOTER //
// ./src/routes/Users/index.js